module.exports = __webpack_public_path__ + "img/usuarios.4ea9efde.svg";